import { useState } from 'react';
import { Box, Button, Popover, Stack, Tooltip } from '@mui/material';
import { CORES } from '../config/paleta';

export function AmostrasCor({ valor, onSelecionar, tamanho = 22 }) {
    return (
        <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
            {CORES.map((cor) => (
                <Box
                    key={cor}
                    component="button"
                    type="button"
                    aria-label={cor}
                    onClick={() => onSelecionar(cor)}
                    sx={{
                        width: tamanho,
                        height: tamanho,
                        borderRadius: '50%',
                        bgcolor: cor,
                        border: 2,
                        borderColor: valor?.toLowerCase() === cor.toLowerCase() ? 'text.primary' : 'transparent',
                        outline: '1px solid rgba(0,0,0,0.12)',
                        cursor: 'pointer',
                        p: 0,
                    }}
                />
            ))}

            <Tooltip title="Outra cor">
                <Box
                    component="input"
                    type="color"
                    value={valor || '#000000'}
                    onChange={(evento) => onSelecionar(evento.target.value)}
                    sx={{
                        width: tamanho + 6,
                        height: tamanho + 6,
                        p: 0,
                        border: 0,
                        bgcolor: 'transparent',
                        cursor: 'pointer',
                    }}
                />
            </Tooltip>
        </Stack>
    );
}

export function BotaoCor({ valor, onSelecionar, onLimpar, children }) {
    const [ancora, setAncora] = useState(null);

    return (
        <>
            <Box component="span" onClick={(evento) => setAncora(evento.currentTarget)}>
                {children}
            </Box>

            <Popover
                open={!!ancora}
                anchorEl={ancora}
                onClose={() => setAncora(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1.5, maxWidth: 260 }}>
                    <AmostrasCor
                        valor={valor}
                        onSelecionar={(cor) => {
                            onSelecionar(cor);
                            setAncora(null);
                        }}
                    />

                    {onLimpar && (
                        <Button
                            size="small"
                            onClick={() => {
                                onLimpar();
                                setAncora(null);
                            }}
                            sx={{ mt: 1 }}
                        >
                            Cor padrão
                        </Button>
                    )}
                </Box>
            </Popover>
        </>
    );
}